(function(){
  angular
    .module('EdxCommonModule')
    .filter('edxTypeOfLearningName', ['edxTypeOfLearning', function(TypeOfLearning){

      var tolToName = {};
      tolToName[TypeOfLearning.EARLY_SENSE_MAKING] = {short: 'Early Sense Making'};
      tolToName[TypeOfLearning.LOOKING_FOR_STRUCTURE] = {short: 'Looking for Structure'};
      tolToName[TypeOfLearning.FLUENTLY_USING_STRUCTURES] = {short: 'Fluency and Practice'};

      return function(tol, disposition) {
        var v;
        if (!!tolToName[tol] && !!tolToName[tol][disposition]) {
          return tolToName[tol][disposition];
        } else if (!!tolToName[tol]) {
          return tolToName[tol].short;
        } else {
          return tol;
        }
      };

    }]);
})();